import { Notes, NoteTone } from "@shared/ui";
import { Instructor } from "@features/events/types";

interface InstructorNotesProps {
  notes?: string;
  tone?: NoteTone;
  loading?: boolean;
  toneOptions: Array<{
    value: NoteTone;
    label: string;
    description: string;
  }>;
  onDataChange?: (updates: Partial<Instructor>) => void;
}

export default function InstructorNotes({
  notes = "",
  tone = "default",
  loading = false,
  toneOptions,
  onDataChange,
}: InstructorNotesProps) {
  return (
    <Notes
      notes={notes}
      tone={tone}
      loading={loading}
      toneOptions={toneOptions}
      onDataChange={onDataChange}
      noteField="privateNote"
      toneField="privateNoteTone"
      asCard={false}
      i18nKeyPrefix="instructorDetails"
    />
  );
}
